import { DeviceToken } from '../../types/User';

export interface TokenRow {
    id: string;
    idDisplay: string;
    type: DeviceToken['type'];
    name: string;
    pairedAt: Date;
    lastUsed?: Date;
    userId: string;
}

export enum TokenState {
    ACTIVE = 'active',
    UNUSED = 'unused',
    DISABLED = 'disabled'
}
